export default __webpack_public_path__ + "static/media/fevr-distribution-periodicity.0f3c94e7.svg";